export default __webpack_public_path__ + "static/media/loginBanner.1a085dce.png";